import { v4 as uuid } from 'uuid';
import { VERSION } from 'config/env';

const SESSION_ID = uuid();

const getTrackingHeaders = () => ({
  'x-self-service-version': VERSION,
  'x-session-id': SESSION_ID,
  'x-correlation-id': uuid(),
});

export default getTrackingHeaders;
